/*  ========================================================================
    # Components - Sections - Submitted Ideas
    ========================================================================  */

// Dependencies
import React, { useContext, useRef, useState } from 'react';
import useResizeObserver from 'use-resize-observer';

// Assets
import Dots from '@images/svg/ui/dots.svg';
import IdeaCard from '../components/IdeaCard';
import { IdeaContext } from '../App';
import IdeaDetails from '../components/IdeaDetails';

const LOAD_MORE_LIMIT = 4;

const SubmittedIdeas = () => {
  const ideas = useContext(IdeaContext);
  const [limit, setLimit] = useState(LOAD_MORE_LIMIT);
  const ideaDetailRefs = useRef([]);
  const canLoadMore = limit < ideas.length;
  const loadMore = () => setLimit(limit + LOAD_MORE_LIMIT);

  const { ref, height } = useResizeObserver({ box: 'border-box' });

  return (
    <>
      {ideas?.length > 0 && (
        <>
          <section id='submitted-ideas' className='s-submitted-ideas'>
            <div className='container'>
              <div className='s-checklist__text'>
                <h2 className='u-text-purple'>Beispiele Eurer Ideen</h2>
                <p>Gewinner von 2022</p>
              </div>
              <div className='s-submitted-ideas__ideas-container' style={{ height: `${height}px` }}>
                <div className='s-submitted-ideas__ideas' ref={ref}>
                  {ideas.slice(0, limit).map((idea, index) => (
                    <IdeaCard
                      key={idea.id}
                      animationOffset={index % LOAD_MORE_LIMIT}
                      idea={idea}
                      onOpen={() => ideaDetailRefs.current?.[index]?.open()}
                    />
                  ))}
                </div>
              </div>
              <button
                disabled={!canLoadMore}
                className='s-submitted-ideas__load-more'
                onClick={loadMore}
              >
                <Dots />
              </button>
            </div>
          </section>
          {ideas.map((idea, index) => (
            <IdeaDetails
              ref={el => (ideaDetailRefs.current[index] = el)}
              key={idea.id}
              idea={idea}
            />
          ))}
        </>
      )}
    </>
  );
};

export default SubmittedIdeas;
